import { render } from "./RunSettings.vue?vue&type=template&id=becd8190"
import script from "./RunSettings.vue?vue&type=script&lang=js"
export * from "./RunSettings.vue?vue&type=script&lang=js"
script.render = render

export default script